import { render, staticRenderFns } from "./ContaUsuario.vue?vue&type=template&id=4298a173&scoped=true&"
import script from "./ContaUsuario.vue?vue&type=script&lang=js&"
export * from "./ContaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ContaUsuario.vue?vue&type=style&index=0&id=4298a173&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298a173",
  null
  
)

export default component.exports